// French law: every review shows its publication date and the date of the
// consumer experience (asked by BV since 2026-09-19, month precision)
export const reviewDates = (
  submissionTime?: string,
  dateOfUserExperience?: string,
) => {
  const dates: string[] = []

  if (submissionTime) {
    dates.push(`Publié le ${dateToString(submissionTime)}`)
  }

  // noon keeps the 1st of the month in the same month whatever the timezone
  if (dateOfUserExperience) {
    const label = dates.length
      ? 'utilise ce produit depuis'
      : 'Utilise ce produit depuis'
    dates.push(
      `${label} ${dateToStringMonthYear(`${dateOfUserExperience}T12:00:00`)}`,
    )
  }

  return dates
}
